import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../../../constants/common'
import {
  useInitData,
  useNotification,
  useTimeZone,
  useUserData,
} from '../../../../../hooks'
import { createAppointment } from '../../../Appointment.api'
import { hasAppointmentFollowUpPrompt } from '../../../Appointment.utils'
import { getAppointmentFormMockContext } from '../../AppointmentFormModal.utils.mock'
import { getAppointmentFormPayload } from '../../AppointmentFormModal.utils.payload'
import { getAppointmentFormSubmitErrors } from '../../AppointmentFormModal.utils.validation'

export function useAppointmentFormSubmit({
  onClose,
  onFollowUpPrompt,
  onSaved = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  const initData = useInitData()

  const timezone = useTimeZone()

  const userData = useUserData()

  const { handleAddSuccessNotification } = useNotification()

  function handleSubmit({ setErrors, setSubmitting, values }) {
    createAppointment({
      data: getAppointmentFormPayload({ organizerId: userData?.id, values }),
      mockContext: getAppointmentFormMockContext({
        restoreJobEnabled:
          initData?.uk?.config?.request_allow_restore_request_on_due_date,
        timezone,
        userData,
        values,
      }),
    })
      .then(({ data }) => {
        handleAddSuccessNotification('Appointment.FormSavedKey')

        onSaved(data)

        if (hasAppointmentFollowUpPrompt(data)) {
          onFollowUpPrompt(data)
        } else {
          onClose()
        }
      })
      .catch(() => {
        setSubmitting(false)

        setErrors(getAppointmentFormSubmitErrors(t))
      })
  }

  return { handleSubmit }
}
